export const headerOnTop = { top: true }
export const menuTitle = { isAnimated: false }
